import ServiciosGenericosDeAPI from 'servicios/ServiciosGenericosDeAPI';
import SeguridadDeSSOUsuario from 'servicios/SeguridadDeSSOUsuario';

class ServiciosDelAPI{
    constructor(){
        this.seguridadDeSSOUsuario=new SeguridadDeSSOUsuario();
        this.user = new ServiciosGenericosDeAPI("user");

        this.informacionYDatosDeEmpresaController = new ServiciosGenericosDeAPI("informacionYDatosDeEmpresaController");
        this.catalogoRangoDeEdades = new ServiciosGenericosDeAPI("catalogoRangoDeEdades");

        this.tarifarioDeMediosTelevisivos = new ServiciosGenericosDeAPI("tarifarioDeMediosTelevisivos");
        this.tarifarioDeMediosRadiales = new ServiciosGenericosDeAPI("tarifarioDeMediosRadiales");
        this.tarifarioDeMediosEscritos = new ServiciosGenericosDeAPI("tarifarioDeMediosEscritos");
        this.tarifarioDePantallasDigitales = new ServiciosGenericosDeAPI("tarifarioDePantallasDigitales");
        this.tarifarioDeVallasFijas = new ServiciosGenericosDeAPI("tarifarioDeVallasFijas");
        this.tarifarioDeVallasMoviles = new ServiciosGenericosDeAPI("tarifarioDeVallasMoviles");

        this.catalogoTipoDeCirculacionDeMedioEscrito = new ServiciosGenericosDeAPI("catalogoTipoDeCirculacionDeMedioEscrito");
        this.catalogoTipoDeMedioEscrito = new ServiciosGenericosDeAPI("catalogoTipoDeMedioEscrito");
        this.catalogoTipoDeDistribucionDeMedioEscrito = new ServiciosGenericosDeAPI("catalogoTipoDeDistribucionDeMedioEscrito");
        this.catalogoTipoDeVallaFija = new ServiciosGenericosDeAPI("catalogoTipoDeVallaFija");
        this.catalogoDepartamentos = new ServiciosGenericosDeAPI("catalogoDepartamentos");
        this.catalogoMunicipios = new ServiciosGenericosDeAPI("catalogoMunicipios");
        this.catalogoSentidoVisualizacion = new ServiciosGenericosDeAPI("catalogoSentidoVisualizacion");
        this.catalogoDeEspaciosPorAsignar = new ServiciosGenericosDeAPI("catalogoDeEspaciosPorAsignar");
        this.catalogoTipoDeTransporte = new ServiciosGenericosDeAPI("catalogoTipoDeTransporte");

        this.administracionDeFechasYFormularios = new ServiciosGenericosDeAPI("administracionDeFechasYFormularios");
        this.organizacionesPoliticas = new ServiciosGenericosDeAPI("organizacionesPoliticas");
        this.usuarios = new ServiciosGenericosDeAPI("usuarios");

        this.empresas = new ServiciosGenericosDeAPI("empresas");
        this.catalogoTipoDeMedioDeComunicacion = new ServiciosGenericosDeAPI("catalogoTipoDeMedioDeComunicacion");
        this.seguridadDeFormularios = new ServiciosGenericosDeAPI("seguridadDeFormularios");
        this.fomularioDeRedesSociales = new ServiciosGenericosDeAPI("fomularioDeRedesSociales");
        this.tarifarioDeRedesSociales = new ServiciosGenericosDeAPI("tarifarioDeRedesSociales");
        this.gestionarDeEspaciosDeMedios = new ServiciosGenericosDeAPI("gestionarDeEspaciosDeMedios");
        this.registrosDePlanDeMedios = new ServiciosGenericosDeAPI("registrosDePlanDeMedios");
        this.catalogoDeMediosPublicos = new ServiciosGenericosDeAPI("catalogoDeMediosPublicos");
        this.gestionarDeMediosAlternativos = new ServiciosGenericosDeAPI("gestionarDeMediosAlternativos");
        this.planDeMediosIntegrado = new ServiciosGenericosDeAPI("planDeMediosIntegrado");
        this.ordenesDeTransmision = new ServiciosGenericosDeAPI("ordenesDeTransmision");
        this.ordenesDeTransmisionPorMedio = new ServiciosGenericosDeAPI("ordenesDeTransmisionPorMedio");
        this.ordenesDeTransmision = new ServiciosGenericosDeAPI("ordenesDeTransmision");
        this.formularioDeRegistroDeMediosDeComunicacion = new ServiciosGenericosDeAPI("formularioDeRegistroDeMediosDeComunicacion");
        this.generarReportes = new ServiciosGenericosDeAPI("generarReportes");
    }
}

export default new ServiciosDelAPI();

